import React from 'react';
import { useStore } from "../../../../../../hooks";
import { observer } from "mobx-react";
import { TemplateContainer } from "../Marketing.styled";
import TemplateEditor from "../../../../../../elements/v2/TemplateEditor/TemplateEditor";
import {EmailTemplateWrapper, MessageEditorError} from "./Message.styled";
import Spinner from "../../../../../../components/common/Spinner";

/**
 * Message component for the Marketing section
 * Renders a template editor for composing marketing messages
 * Displays validation errors when required fields are missing
 */
const Message = observer(() => {
  const { marketingStore } = useStore();
  const { messageStore } = marketingStore;

  if (!marketingStore.currentCampaign) {
    return <Spinner />;
  }
  
  return (
    <TemplateContainer>
      <EmailTemplateWrapper>
        {
          messageStore.templateEditorStore.requiredFieldsError &&
          (
            <MessageEditorError>One or more required fields are missing. Please review the form and complete all mandatory fields before submitting.</MessageEditorError>
          )
        }
        <TemplateEditor
          store={messageStore.templateEditorStore}
          key={`main-message-${messageStore.id}`}
          isPopup={false}
        />
      </EmailTemplateWrapper>
    </TemplateContainer>
  );
});

export default Message;
